import commonUtils from "@/utils/common.utils";

export default class memberCouponModel {
    constructor(data = {}) {
        this.cheapen = data.cheapen || null;
        this.coupon_type = data.coupon_type || 3;
        this.coupon_uuid = data.coupon_uuid || '';
        this.del_useable = data.del_useable || null;
        this.deleted = data.deleted || 0;
        this.description = data.description || '';
        this.discount = data.discount || null;
        this.extra_price = data.extra_price || null;
        this.first_time = data.first_time || 1;
        this.for_product = data.for_product || '';
        this.free_shipping_type = data.free_shipping_type || null;
        this.is_continue = data.is_continue || 0;
        this.is_unlimit = data.is_unlimit || 1;
        this.is_used = data.is_used || 0;
        this.issue_min_price = data.issue_min_price || 0;
        this.point_change = data.point_change || null;
        this.points = data.points || null;
        this.product_price = data.product_price || null;
        this.publish_begin = data.publish_begin ? commonUtils.convertDate(data.publish_begin) : null;
        this.publish_end = data.publish_end ? commonUtils.convertDate(data.publish_end) : null;
        this.publish_scope = data.publish_scope || 1;
        this.quantity_limit = data.quantity_limit || 0;
        this.status = data.status || 1;
        this.store_code = data.store_code || '';
        this.title = data.title || '';
        this.usage_period_begin = data.usage_period_begin ? commonUtils.convertDate(data.usage_period_begin) : null;
        this.usage_period_end = data.usage_period_end ? commonUtils.convertDate(data.usage_period_end) : null;
        this.use_min_price = data.use_min_price || 0;
        this.use_scope = data.use_scope || 1;
        this.vip_level = data.vip_level || '';
    }
}